module.exports = __webpack_public_path__ + "assets/img/icon7-menu.20f4f384.svg";